import { apiClient } from '../../../v4/core/apiClient';
import { createResourceApi } from './resource.api.http';
import { myMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService.connected';

export const myResourceApi = createResourceApi({
  client: apiClient,
  services: { metastructureMappingService: myMetastructureMappingService }
});
